import React, { useState } from 'react'
import { EmailIconSvg } from '../assets/svg/SvgComponent';
import { useBranding } from '../context/BrandingContext';
import axios from 'axios';
import { API_URL, getHeaders } from '../helper/commonApi';
import { useNavigate } from 'react-router-dom';

const ForgotPasswordComponent = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState("");

    const { colors, portalID } = useBranding();

    const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const handleForgotPassword = async () => {
        const validationErrors = {};

        if (!email.trim()) {
            validationErrors.email = "Email is required.";
        } else if (!validateEmail(email)) {
            validationErrors.email = "Enter a valid email.";
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(`${API_URL}/forgot-password`, {
                portal_id: portalID,
                email: email,
            }, {
                headers: getHeaders()
            });

            if (res.status === 200 && res?.data?.status) {
                const userId = res?.data?.data?.user_id;

                localStorage.setItem('_register_GRE_userEmail', email)
                localStorage.setItem('_register_GRE_userId', userId)
                localStorage.setItem('_register_GRE_forgot_password', true)

                navigate("/verify-mail");
                // await handleResendOtp(userId);
            } else {
                setApiError(res?.data?.message || "Invalid OTP.");
            }
        } catch (err) {
            setApiError("Something went wrong.");
        } finally {
            setLoading(false);
        }
    }

    // const handleResendOtp = async (userId) => {
    //     setLoading(true);
    //     try {
    //         const res = await axios.post(`${API_URL}/resend-otp`, {
    //             email: email,
    //             portal_id: portalID,
    //             user_id: userId,
    //         }, {
    //             headers: getHeaders()
    //         });

    //         if (res.status === 200 && res?.data?.status) {
    //             navigate("/verify-mail");
    //         } else {
    //             setApiError(res?.data?.message || "Invalid OTP.");
    //         }
    //     } catch (err) {
    //         setApiError("Something went wrong.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };


    return (
        <div>
            <div style={{ margin: "10px" }}>
                <div className="container">
                    <div className="verify-otp-section">
                        <h2 class="text-3xl font-semibold text-black mb-2">Forgot Password</h2>
                        <p class="text-gray-600 mb-6">Enter your registered email to reset your password</p>

                        <div className="form">
                            <div className="input-wrapper">
                                <div className={`input-group ${errors.email ? "error" : ""}`}>
                                    <EmailIconSvg />
                                    <input
                                        id="email"
                                        name='email'
                                        type="email"
                                        placeholder="Enter your mail here"
                                        value={email}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setEmail(val);
                                            if (!val.trim()) {
                                                setErrors((prev) => ({ ...prev, email: "Email is required." }));
                                            } else if (!validateEmail(val)) {
                                                setErrors((prev) => ({ ...prev, email: "Enter a valid email." }));
                                            } else {
                                                setErrors((prev) => ({ ...prev, email: undefined }));
                                            }
                                        }}

                                    />
                                </div>
                                {errors.email && <span className="error-text">{errors.email}</span>}
                            </div>

                            {apiError && <p className="verify-otp-error">{apiError}</p>}

                            <button
                                className="register-btn btn black"
                                onClick={handleForgotPassword}
                                disabled={loading}
                                style={{ backgroundColor: colors?.buttonBg }}
                            >
                                {loading ? <span className="loader-small" /> : "Continue"}
                            </button>

                        </div>

                    </div>
                </div></div>
        </div>
    )
}

export default ForgotPasswordComponent